import React from 'react';
import PropTypes from 'prop-types';
import round from 'lodash/round';
import groupBy from 'lodash/groupBy';
import { Roles } from '../../../core/util';
import Table from '../../../core/form/Table';
import Tag from '../../../core/layout/Tag';
import Button from '../../../core/form/Button';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import moment from 'moment';

const UsageStatsList = (props) => {
  const children = props.companies.reduce((children1, company) => {
    return [...children1, ...company.academicPlans];
  }, []);

  const academicPlans = groupBy(children, 'academicPlan.name');

  return (
    <div>
      <Table
        fetching={props.fetching}
        columns={[
          {
            label: 'Company',
            path: 'name',
            defaultSortOrder: 'asc',
            sort: true,
          },
          {
            label: 'Status',
            path: 'deleted',
            sort: true,
            width: '150px',
            align: 'center',
            render: (value, row) => (
              <>
                <Tag color={value ? 'red' : 'green'}>
                  {value ? 'Churned' : 'Active'}
                  {value && (
                    <span>
                      {' - '}
                      {moment(row.deletedAt).format('DD/MM/YYYY')}
                    </span>
                  )}
                </Tag>
              </>
            ),
          },
          {
            label: 'Active Students',
            path: 'activeStudents',
            sort: true,
            width: '150px',
            align: 'center',
            render: (value) => value || 0,
          },
          {
            label: 'Placement Tests Only',
            path: 'placementCount',
            width: '180px',
            sort: true,
            align: 'center',
            render: (value) => value || 0,
          },
          {
            label: 'Students to Charge',
            path: 'currentCharge',
            width: '180px',
            sort: true,
            align: 'center',
          },
          {
            label: 'Variation',
            path: 'chargeVariation',
            width: '180px',
            sort: true,
            align: 'center',
            render: (value, row) => ({
              children: (
                <div>
                  <Tag color={!value ? null : value > 0 ? 'green' : 'red'}>
                    {round(value, 1)}%
                    {localStorage.role === Roles.ADMIN && <span> over {row.previousPeriodCharge}</span>}
                  </Tag>
                </div>
              ),
            }),
          },
          {
            label: 'Actions',
            path: 'action',
            width: '75px',
            align: 'center',
            render: (cell, row) => {
              return <Button icon="solution" onClick={() => props.onShowDetails(row.id)} />;
            },
          },
        ]}
        rows={props.companies}
        rowClassName={(row, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        expandableComponent={(row) => (
          <Table
            rowKey={(row) => `${row.id.academicPlan}-${row.id.company}`}
            bordered={false}
            columns={[
              {
                label: 'Academic plan',
                path: 'academicPlan.name',
                defaultSortOrder: 'asc',
              },
              {
                label: 'Active Students',
                path: 'activeStudents',
                width: '150px',
                align: 'center',
                render: (cell) => ({
                  children: cell || 0,
                }),
              },
              {
                label: 'Placement Tests Only',
                path: 'placementCount',
                width: '180px',
                align: 'center',
                render: (cell) => ({
                  children: cell || 0,
                }),
              },
              {
                label: 'Students to Charge',
                path: 'currentCharge',
                width: '180px',
                align: 'center',
              },
              {
                label: 'Variation',
                path: 'chargeVariation',
                width: '180px',
                sort: true,
                align: 'center',
                render: (value, row) => ({
                  children: (
                    <div>
                      <Tag color={value > 0 ? 'green' : 'red'}>
                        {round(value, 1)}%
                        {localStorage.role === Roles.ADMIN && <span> over {row.previousPeriodCharge}</span>}
                      </Tag>
                    </div>
                  ),
                }),
              },
              // {
              //   label: 'Studied Time',
              //   path: 'studiedHours',
              //   width: '150px',
              //   align: 'center',
              //   render: (value) => ({
              //     children: formatTimeFromSeconds(value, 'hh:mm'),
              //   }),
              // },
              {
                label: '',
                path: 'gap',
                width: '74px',
              },
            ]}
            rows={row.academicPlans}
            showTableCount={false}
          />
        )}
        showTableCount={false}
      />
      {!!props.companies.length && (
        <>
          <Row>
            <Column>
              <div
                style={{
                  display: 'flex',
                  padding: '5px 0px',
                  border: '1px solid #e8e8e8',
                  borderTop: 'none',
                  marginTop: -10,
                }}
              >
                <span
                  style={{
                    display: 'flex',
                    flex: 1,
                    paddingLeft: 10,
                  }}
                >
                  Total
                </span>
                <span
                  style={{
                    width: 150,
                    textAlign: 'center',
                  }}
                >
                  {props.companies.reduce((acc, x) => acc + (x.activeStudents || 0), 0)}
                </span>
                <span
                  style={{
                    width: 180,
                    textAlign: 'center',
                  }}
                >
                  {props.companies.reduce((acc, x) => acc + (x.placementCount || 0), 0)}
                </span>
                <span
                  style={{
                    width: 180,
                    textAlign: 'center',
                  }}
                >
                  {props.companies.reduce((acc, x) => acc + ((x.activeStudents || 0) - (x.placementCount || 0)), 0)}
                </span>
                <span
                  style={{
                    width: 180,
                    textAlign: 'center',
                  }}
                ></span>
                <span
                  style={{
                    width: 75,
                  }}
                ></span>
              </div>
            </Column>
          </Row>
          {Object.keys(academicPlans)
            .sort()
            .map((academicPlan) => (
              <Row>
                <Column>
                  <div
                    style={{
                      display: 'flex',
                      padding: '5px 0px',
                      border: '1px solid #e8e8e8',
                      borderTop: 'none',
                    }}
                  >
                    <span
                      style={{
                        display: 'flex',
                        flex: 1,
                        paddingLeft: 30,
                      }}
                    >
                      {academicPlan}
                    </span>
                    <span
                      style={{
                        width: 150,
                        textAlign: 'center',
                      }}
                    >
                      {academicPlans[academicPlan].reduce((acc, record) => acc + (record.activeStudents || 0), 0)}
                    </span>
                    <span
                      style={{
                        width: 180,
                        textAlign: 'center',
                      }}
                    >
                      {academicPlans[academicPlan].reduce((acc, record) => acc + (record.placementCount || 0), 0)}
                    </span>
                    <span
                      style={{
                        width: 180,
                        textAlign: 'center',
                      }}
                    >
                      {academicPlans[academicPlan].reduce((acc, record) => acc + (record.currentCharge || 0), 0)}
                    </span>
                    <span
                      style={{
                        width: 180,
                        textAlign: 'center',
                      }}
                    ></span>
                    <span
                      style={{
                        width: 75,
                      }}
                    ></span>
                  </div>
                </Column>
              </Row>
            ))}
        </>
      )}
    </div>
  );
};

UsageStatsList.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      activeStudents: PropTypes.number,
      placementCount: PropTypes.number,
      studiedHours: PropTypes.number,
      schools: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          activeStudents: PropTypes.number,
          placementCount: PropTypes.number,
          studiedHours: PropTypes.number,
        })
      ),
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onShowDetails: PropTypes.func.isRequired,
};

export default UsageStatsList;
